import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { Router, RouterModule } from '@angular/router';

import { UserService } from './services/user.service';
import { DataService } from './services/data.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UtilService } from './services/util.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {
  user: any;
  error = false;
  status: number;
  actions: any[];

  helpFileRef$: Observable<string>;

  constructor(
    private userService: UserService,
    private dataService: DataService,
    private utilService: UtilService,
    private router: Router,
    private title: Title) {}

  ngOnInit() {

    this.helpFileRef$ = this.dataService.getAppConfig().pipe(
      map((result: any) => result.documentRepository.helpFile)
    );

    this.userService.getUserProfile().subscribe(
      user => {
        this.user = user;

        try {
          if (['', '#/'].indexOf(window.location.hash) > -1) {
            this.router.navigate([user.profile.links[Object.keys(user.profile.links)[0]].path]);
          } else {
          }
        } catch (error) {
          console.error('unable to launch default path', error.message);
        }

        try {
          const lookup = {
            DH: 'TTAB Reading Room'
          };

          this.title.setTitle( lookup[this.user.platform] || 'PTAB');

        } catch (error) {
          console.error('title', error.message);
        }

        this.actions = Object.keys(user.profile.links).map(key => {
          return {
            'routerLink': user.profile.links[key].path,
            'label': user.profile.links[key].label
          };
        });

      },

      err => {
        console.error('app.comp', err);
        this.error = true; this.status = err.status;
      }

    );
  }

  showHidePageIntro(event:Event) {
    this.utilService.showHidePageIntro();
    event.preventDefault();
  }
}
